import { Box, Grid, Typography } from "@mui/material"
import React from "react"
import { Props } from "./DocumentBox.interfaces"
import DocumentBox from "./DocumentBox/DocumentBox"
import { useTranslation } from "react-i18next"

const DocumentsComponent: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  return (
    <Box padding={2}>
      {props.attachments && props.attachments.length > 0 && (
        <>
          <Typography variant="h3" marginLeft={2} marginTop={2}>
            {t("documents.title ", "Documents")}
          </Typography>
          <Grid container>
            {props.attachments.map(function (attachment) {
              return (
                <Grid item>
                  <DocumentBox data={attachment} />
                </Grid>
              )
            })}
          </Grid>
        </>
      )}
    </Box>
  )
}

export default DocumentsComponent
